import { IModel, Model } from '@common/models';

export interface IPetVisitRemindersModel extends IModel {
  petId: number;
  visitId?: number;
  visitSalesItemId?: number;
  salesItemId: number;
  givenDate: string;
  dueDate: string;
  description: string;
  name: string;
  fullName: string;
  price?: number;
  isPending?: boolean;
  reminderDays: number;
  pastDueDate: boolean;
  isComingDue: boolean;
  given: boolean;
  salesItemTypeId?: number;
  petCustomReminderId?: number;
  reminderSourceId?: number;
  isCustomReminder: boolean;
  storeId?: number;
  allowCustomReminders: boolean;
}

export class PetVisitReminderModel
  extends Model
  implements IPetVisitRemindersModel
{
  petId: number;
  visitId?: number;
  visitSalesItemId?: number;
  salesItemId: number;
  givenDate: string;
  dueDate: string;
  description: string;
  name: string;
  fullName: string;
  price?: number;
  isPending?: boolean;
  reminderDays: number;
  pastDueDate: boolean;
  isComingDue: boolean;
  given: boolean;
  salesItemTypeId?: number;
  petCustomReminderId?: number;
  reminderSourceId?: number;
  isCustomReminder: boolean;
  storeId?: number;
  allowCustomReminders: boolean;

  constructor(params: IPetVisitRemindersModel) {
    super(params);
    this.petId = _.defaultTo(params.petId, 0);
    this.visitId = _.defaultTo(params.visitId, 0);
    this.visitSalesItemId = _.defaultTo(params.visitSalesItemId, 0);
    this.salesItemId = _.defaultTo(params.salesItemId, 0);
    this.givenDate = _.defaultTo(params.givenDate, '');
    this.dueDate = _.defaultTo(params.dueDate, '');
    this.description = _.defaultTo(params.description, '');
    this.name = _.defaultTo(params.name, '');
    this.fullName = _.defaultTo(params.fullName, '');
    this.price = _.defaultTo(params.price, 0);
    this.isPending = _.defaultTo(params.isPending, false);
    this.reminderDays = _.defaultTo(params.reminderDays, 0);
    this.pastDueDate = _.defaultTo(params.pastDueDate, false);
    this.isComingDue = _.defaultTo(params.isComingDue, false);
    this.given = _.defaultTo(params.given, false);
    this.salesItemTypeId = _.defaultTo(params.salesItemTypeId, 0);
    this.petCustomReminderId = _.defaultTo(params.petCustomReminderId, 0);
    this.reminderSourceId = _.defaultTo(params.reminderSourceId, 0);
    this.isCustomReminder = _.defaultTo(params.isCustomReminder, false);
    this.storeId = _.defaultTo(params.storeId, 0);
    this.allowCustomReminders = _.defaultTo(params.allowCustomReminders, false);
  }
}
